import {
  getLocalStorageWithExpiry,
  setLocalStorageWithExpiry,
} from "@redotech/redo-web/utils/local-storage-wrapper";
import {
  getSessionStorageWithExpiry,
  setSessionStorageWithExpiry,
} from "@redotech/redo-web/utils/session-storage-wrapper";
import { log } from "../monitoring/log";

const PREVIEW_LOCAL_STORAGE_KEY = "redo_preview";
const PREVIEW_SESSION_STORAGE_KEY = "redo_preview";
const PREVIEW_MODE_TRUE_FALSE_PARAM = "preview";
const PREVIEW_MODE_VALUE_PARAM = "redo.mode";

export const PreviewModeState = {
  isActive(): boolean {
    const urlParams = new URLSearchParams(location.search);

    const fromUrlPreview =
      urlParams.get(PREVIEW_MODE_TRUE_FALSE_PARAM) === "true";
    const fromUrlRedoMode =
      urlParams.get(PREVIEW_MODE_VALUE_PARAM) === "preview";
    const fromLocalStorage =
      getLocalStorageWithExpiry(PREVIEW_LOCAL_STORAGE_KEY) === true;
    const fromSessionStorage =
      getSessionStorageWithExpiry(PREVIEW_SESSION_STORAGE_KEY) === true;
    const fromGlobalFlag = globalThis.redoMode === "preview";

    const isActive =
      fromUrlPreview ||
      fromUrlRedoMode ||
      fromLocalStorage ||
      fromSessionStorage ||
      fromGlobalFlag;

    return isActive;
  },

  getActiveAndSet(): boolean {
    const isActive = this.isActive();
    if (isActive) {
      this.enable();
    }
    return isActive;
  },

  enable(): void {
    try {
      setLocalStorageWithExpiry(PREVIEW_LOCAL_STORAGE_KEY, true, 0.05);
      setSessionStorageWithExpiry(PREVIEW_SESSION_STORAGE_KEY, true, 1);
      globalThis.redoMode = "preview";

      log("Preview mode enabled");
    } catch (error) {
      console.error("Error enabling preview mode:", error);
    }
  },

  disable(): void {
    try {
      localStorage.removeItem(PREVIEW_LOCAL_STORAGE_KEY);
      sessionStorage.removeItem(PREVIEW_SESSION_STORAGE_KEY);

      if (globalThis.redoMode === "preview") {
        delete globalThis.redoMode;
      }

      const url = new URL(window.location.href);
      url.searchParams.delete(PREVIEW_MODE_TRUE_FALSE_PARAM);
      url.searchParams.delete(PREVIEW_MODE_VALUE_PARAM);
      window.history.replaceState({}, "", url.toString());

      log("Preview mode disabled");
    } catch (error) {
      console.error("Error disabling preview mode:", error);
    }
  },

  exitAndReload(): void {
    try {
      this.disable();
      window.location.reload();

      log("Preview mode exited, page reloading");
    } catch (error) {
      console.error("Error exiting preview mode:", error);
    }
  },
};
